import { Grid, Fade, Typography, IconButton } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'

import policy from '../resources/privacy-policy.pdf';
import { isWeb } from '../app/utils';
import PDFViewer from '../components/PDFViewer';
import { useMemo } from 'react';
import useBack from '../hooks/useBack';

export default function Privacy(){

  const web = useMemo(() => isWeb(), [])
  const goBack = useBack();

  return <Grid
    container justifyContent="center"
    sx={{
      width: 1, minHeight: '100vh', height: web ? '100vh' : 1, background: '#f2f2f2'
    }}
  >
    <Fade in exit mountOnEnter unmountOnExit>
    <Grid
      size={{ xs: 12, sm: 8, md: 6 }}
      container
      direction="column"
      justifyContent="center"
      alignItems="stretch"
      p={3}
      spacing={3}
    >
      <Grid container justifyContent="flex-start" alignItems="center" spacing={2}>
        <Grid>
          <IconButton onClick={() => goBack()} color="primary">
            <ArrowBack />
          </IconButton>
        </Grid>
        <Grid>
          <Typography variant="h6" color="text.primary">
            Privacy Policy
          </Typography>
        </Grid>
      </Grid>
      <Grid sx={{ flex: '1', width: 1 }}>
      {
        web ?
        <iframe
          title="privacy-policy-file"
          src={
            window.location.hostname === 'localhost' ?
            policy :
            `https://docs.google.com/gview?url=${window.location.host}${policy}&embedded=true`
          }
          style={{ width: '100%', height: '100%' }} frameBorder="0"
        >
          <Typography color="text.primary">
            Impossibile leggere il file.
          </Typography>
        </iframe> :
        <PDFViewer url={policy} sx={{
          width: 1,
          height: 1,
          "& canvas": {
            maxHeight: "calc(100% - 48px)",
            maxWidth: 1,
            width: "fit-content",
            margin: "auto"
          }
        }} />
      }
      </Grid>
    </Grid>
    </Fade>
  </Grid>
}